import React, { useEffect } from 'react';

import { useStores } from 'util/mobx/stores';
import { MaterialLikeIdOrPackageIdDTO } from 'dto/material';
import StorageLocationsList from 'pages/locationAdministration/StorageLocationsList';
import StorageLocationDetails from 'pages/locationAdministration/StorageLocationDetails';
import { observer } from 'mobx-react';
import { LocationSource } from 'dto/storageLocation';

interface Props {
  materialLikeOrPackageId: MaterialLikeIdOrPackageIdDTO;
  inFlyout?: boolean;
}

const MaterialLikeStorageLocations = observer(({ materialLikeOrPackageId, inFlyout = false }: Props) => {
  const { storageLocationStore, domainStore } = useStores();
  useEffect(() => {
    if (inFlyout) {
      return undefined;
    }
    storageLocationStore.setMaterialLikeId(materialLikeOrPackageId);
    storageLocationStore.loadMaterialLikeLocations(undefined, LocationSource.KPS);
    return () => {
      if (!inFlyout) {
        storageLocationStore.refreshMaterialLikeData();
      }
    };
  }, [storageLocationStore, materialLikeOrPackageId, domainStore.currentFunctionalArea.id, inFlyout]);

  if (inFlyout) {
    return <StorageLocationsList assignedToMaterial inFlyout />;
  }
  return (
    <div className="w-layout-grid grid_colum_content_lagerorte">
      <StorageLocationsList assignedToMaterial />
      {storageLocationStore.selectedMaterialStorageLocation && (
        <StorageLocationDetails selectedStorageLocation={storageLocationStore.selectedMaterialStorageLocation} />
      )}
    </div>
  );
});

export default MaterialLikeStorageLocations;
